import React from 'react';
import Skeleton from '../Skeleton';
import styles from './SimpleTable.module.css';

const CLASSE_DO_ALINHAMENTO = {
    centro: styles.centro,
    direita: styles.direita,
};

export default function SimpleTable({
    colunas,
    linhas,
    chaveDaLinha,
    textoVazio = 'Nenhum registro encontrado.',
    linhaSelecionada,
    corDoMarcador,
    onClickLinha,
    alturaMaxima,
    compacta = false,
    carregando = false,
    linhasEsperadas = 5,
}) {
    if (!carregando && linhas.length === 0) {
        return <p className={styles.vazio}>{textoVazio}</p>;
    }

    const classeDaCelula = (coluna) => CLASSE_DO_ALINHAMENTO[coluna.alinhamento] || '';

    return (
        <div className={styles.wrapper} style={alturaMaxima ? { maxHeight: alturaMaxima } : undefined}>
            <table className={`${styles.tabela} ${compacta ? styles.compacta : ''}`}>
                <thead>
                    <tr>
                        {colunas.map((coluna) => (
                            <th key={coluna.chave} className={classeDaCelula(coluna)}>{coluna.titulo}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {carregando && Array.from({ length: linhasEsperadas }, (_, indice) => (
                        <tr key={`esqueleto-${indice}`} aria-busy="true">
                            {colunas.map((coluna) => (
                                <td key={coluna.chave} className={classeDaCelula(coluna)}><Skeleton width="80%" height={14} /></td>
                            ))}
                        </tr>
                    ))}
                    {!carregando && linhas.map((linha) => {
                        const classes = [
                            onClickLinha ? styles.clicavel : '',
                            linhaSelecionada?.(linha) ? styles.selecionada : '',
                        ].join(' ').trim();

                        return (
                            <tr key={chaveDaLinha(linha)} className={classes} onClick={onClickLinha ? () => onClickLinha(linha) : undefined}>
                                {colunas.map((coluna, indice) => (
                                    <td key={coluna.chave} className={classeDaCelula(coluna)}>
                                        {indice === 0 && corDoMarcador ? (
                                            <span className={styles.celulaComMarcador}>
                                                <span className={styles.marcador} style={{ background: corDoMarcador(linha) }} />
                                                <span>{coluna.renderizar(linha)}</span>
                                            </span>
                                        ) : coluna.renderizar(linha)}
                                    </td>
                                ))}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}
